module.exports = __webpack_public_path__ + "img/done.86123130.svg";